import { ChangeEvent, useEffect, useRef, useState } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { Resolver, useForm } from 'react-hook-form';
import { COST_CENTRE_ERRORS } from 'shared/constants/GenericMessages';
import { FormWithValidation } from 'shared/form';
import { FileCard, MainCard } from './MassFundsDistributionForm.styles';
import { MassFundsDistributionList } from '../MassFundsDistributionList/MassFundsDistributionList';
import { formatCurrency } from 'shared/utils';
import { useNotifications } from 'shared/notifications';
import { UploadFileButton } from 'shared/form/components/UploadFileButton';

interface FormValues {
  [key: string]: any;
}

/**
 * TODO: Refactorizar este componente para eliminar el uso del estado dentro del formulario ya que va a traer problemas de performance
 */
const formResolver: Resolver<FormValues> = async (values, { setSelected }) => {
  const errors = {};
  setSelected((selectedParent: any) => {
    if (
      !!values['parentCostCentre'] &&
      values['parentCostCentre'].value.formattedName !== selectedParent?.formattedName
    ) {
      return values['parentCostCentre'].value;
    }
    return selectedParent;
  });

  return {
    values,
    errors,
  };
};

export const MassFundsDistributionForm = (props: { availableCostCentres: any }) => {
  const [selectedParent, setSelectedParent] = useState<any>(null);
  const [uploadedFile] = useState<File>(null);
  const { addNotification } = useNotifications();
  const methods = useForm({
    resolver: formResolver,
    context: {
      setSelected: setSelectedParent,
    },
  });
  const {
    // eslint-disable-next-line
    formState: { errors, isValid, isSubmitted },
    reset,
    unregister,
    getValues,
  } = methods;

  // create ref
  const fileLink = useRef<HTMLAnchorElement>();

  const onFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files.item(0);
    if (file.size > 1024 * 1024) {
      addNotification('El tamaño máximo de archivo es 1MB', 'error');
    } else if (file.name.toLowerCase().endsWith('.csv')) {
      // uploadTemplate(e.target.files[0]).then((r) => {
      //   if (!!r) {
      //     setUploadedFile(file);
      //   }
      // });
    } else {
      addNotification('El tipo de archivo debe ser .csv', 'error');
    }
  };

  const doDownloadTemplate = () => {
    // downloadTemplate(selectedParent || ({} as any), getChildren()).then((response) => {
    //   if (response !== null) {
    //     fileLink.current.href = response.url;
    //     fileLink.current.download = response.name;
    //     fileLink.current.click();
    //   }
    // });
  };

  useEffect(() => {
    for (const key in getValues()) {
      if (key.startsWith('children')) {
        unregister(key);
      }
    }
    reset(
      {},
      {
        keepValues: true,
        keepDirty: false,
      },
    );
  }, [selectedParent, unregister, getValues, reset]);

  return (
    <FormWithValidation reactFormHookMethods={methods} onSubmit={() => {}}>
      <MainCard>
        <Card.Header>Centros de costos</Card.Header>
        <Card.Body>
          <Form.Group as={Row} className="mb-3" controlId="selectParent">
            <Form.Label column sm="3">
              Centro de costo origen
              <p>{`Saldo: ${formatCurrency(selectedParent?.disponible.disponible)}`}</p>
            </Form.Label>
            <Col sm="9">
              <FormWithValidation.LegacySelect
                isSearchable={true}
                options={props.availableCostCentres.optionsList}
                placeholder="Seleccione un padre"
                name="parentCostCentre"
                registerOptions={{
                  required: COST_CENTRE_ERRORS.originCostCentreRequired,
                }}
              />
              <FormWithValidation.Control.Feedback
                type="invalid"
                controlId="parentCostCentre"
              />
            </Col>
          </Form.Group>
          {!!selectedParent && (
            <Form.Group as={Row} className="mb-3" controlId="selectChildren">
              <Form.Label column sm="3">
                Centro de costo destino
              </Form.Label>
              <Col sm="9">
                <MassFundsDistributionList centrosCosto={selectedParent.hijos} />
              </Col>
            </Form.Group>
          )}
        </Card.Body>
      </MainCard>
      <FileCard>
        <Card.Body>
          <Button
            type="button"
            variant="outline-secondary"
            size="lg"
            className="me-3"
            onClick={doDownloadTemplate}
          >
            Descargar template
          </Button>
          <a href="/" download="default.csv" ref={fileLink} hidden>
            link
          </a>
          <UploadFileButton file={uploadedFile} onChange={onFileChange} />
          <Button type="button" variant="outline-success" size="lg" className="me-3">
            Realizar transferencia
          </Button>
        </Card.Body>
      </FileCard>
    </FormWithValidation>
  );
};
